import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import request from '../../lib/requester';
import moment from 'moment';
import _ from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';

class CoverLetter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			terbilang: '',
			total: 0,
			claim_number: '',
			start_date: new Date(),
			end_date: new Date(),
			principal_code: '',
			lovPrincipal: [],
			dataTable: [],
			dataOrganization: {},
			sequence: '',
			coverLetterPath: '',
			user: JSON.parse(window.localStorage.getItem('is_user')) || {},
		};
	}

	componentDidMount = () => {
		this.getPrincipal();
	};

	getPrincipal = () => {
		let url = '/api/infostep/v1/general/list-principal';
		request.getInfostep(url, {
			success: function (response) {
				this.setState({ lovPrincipal: response.data.data });
			}.bind(this),
			error: function (e) {
				console.log(e);
			},
		});
	};

	handleChangeInput = (event) => {
		let value = event.target.value;
		let name = event.target.name;

		this.setState({ [name]: value });
	};

	handleStartDate = (date) => {
		this.setState({ start_date: date });
	};

	handleEndDate = (date) => {
		this.setState({ end_date: date });
	};

	renderLovPrincipal = () => {
		return (
			<select
				className='form-control'
				name='principal_code'
				value={this.state.principal_code}
				onChange={this.handleChangeInput.bind(this)}
			>
				<option value=''>- Select Principal -</option>
				{this.state.lovPrincipal.map((item, index) => (
					<option value={item.org_initial}>{item.org_name}</option>
				))}
			</select>
		);
	};

	handleGenerate = () => {
		let { claim_number, start_date, end_date, principal_code } = this.state;
		if (principal_code === '' || principal_code.length === 0) {
			alert('Please select principal');
			return false;
		}
		let url = '/api/traces/v1/document/generate-coverletter';
		let param = {
			start_date: moment(start_date).format('YYYY-MM-DD') || '',
			end_date: moment(end_date).format('YYYY-MM-DD') || '',
			claim_number: claim_number || '',
			principal_code: principal_code || '',
			user_name: this.state.user.username,
			source: 'arman',
			menu: 'awb',
			function: 'cover letter',
		};
		this.setState({ loading: true });
		request.postTraces(url, param, {
			success: function (response) {
				let { data } = response.data;
				this.setState({ loading: false });
				if (data.claim.length === 0) {
					alert('No result found!');
					return false;
				} else {
					let app = this;
					let detailOrg = _.find(this.state.lovPrincipal, function (o) {
						return o.org_initial === app.state.principal_code;
					});
					this.setState({
						dataTable: data.claim,
						sequence: data.sequence,
						dataOrganization: detailOrg || {},
						total: data.total,
						terbilang: data.terbilang,
					});
					window.setTimeout(() => {
						app.exportPDF();
					}, 200);
				}
			}.bind(this),
			error: function (e) {
				this.setState({ loading: false });
			}.bind(this),
		});
	};

	thousandSeparator = (value) => {
		value = value.toString();
		value = value.replace(/,/g, '').replace(/[^0-9.]/g, '');
		var parts = value.toString().split('.');
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
		return parts.join('.');
	};

	exportPDF = () => {
		let url = '/api/traces/v1/document/print-cover-letter';
		let param = {
			data: this.state,
		};
		request.postTraces(url, param, {
			success: function (response) {
				const { success, path, filename, message } = response.data;
				if (success) {
					const fullpath = request.getFileS3(path, filename);
					this.setState({ coverLetterPath: fullpath });
				} else {
					alert(message);
				}
			}.bind(this),
			error: function (e) {
				alert('Cover Letter Failed to generated');
			},
		});
	};
	exportPDF2 = () => {
		const unit = 'pt';
		const size = 'A4'; // Use A1, A2, A3 or A4
		const orientation = 'portrait'; // portrait or landscape
		const doc = new jsPDF(orientation, unit, size);
		const headers = [
			[
				'No',
				'Branch',
				'Customer Name',
				'Program Name',
				'Reimbursement Date',
				'Claim No',
				'Value',
			],
		];

		const data = this.state.dataTable.map((elt, index) => [
			index + 1,
			elt.branch_code,
			elt.customer_name,
			elt.program_name,
			moment(elt.awb_confirmed_date).format('DD-MMM-YYYY'),
			elt.claim_number,
			this.thousandSeparator(parseInt(elt.total)),
		]);

		let rowTotal = [
			'',
			'',
			'',
			'',
			'',
			'Total',
			this.thousandSeparator(this.state.total),
		];
		data.push(rowTotal);

		// Kop Surat
		console.log(doc.getFontList());
		doc.setFontSize(9);
		// doc.setFontType("bold");
		doc.setFont('helvetica', 'bold');
		doc.text(
			'Tangerang, ' + moment(new Date()).format('DD-MMM-YYYY'),
			440,
			120
		);
		doc.text(this.state.sequence, 40, 120);

		// doc.setFontType("normal");
		doc.setFont('helvetica', 'normal');
		doc.text('Kepada Yth,', 40, 145);

		// doc.setFontType("bold");
		doc.setFont('helvetica', 'bold');
		doc.text(this.state.dataOrganization.org_name, 40, 159);

		// doc.setFontType("normal");
		doc.setFont('helvetica', 'normal');
		doc.text(this.state.dataOrganization.address1, 40, 173);
		doc.text(this.state.dataOrganization.address2, 40, 187);
		doc.text(this.state.dataOrganization.address3, 40, 201);

		// doc.setFontType("bold");
		doc.setFont('helvetica', 'bold');
		doc.text('Up. ' + this.state.dataOrganization.cp_name, 40, 215);
		doc.text(
			'Hal: Reimbursement atas Biaya Program Principal di Relasi Potong Piutang AAM.',
			40,
			240
		);

		// doc.setFontType("normal");
		doc.setFont('helvetica', 'normal');
		doc.text('Dengan hormat,', 40, 265);
		var terbilang =
			'Bersama ini kami kirimkan reimbursement atas biaya program principal di relasi yang potong piutang PT. AAM periode ' +
			moment(this.state.start_date).format('DD-MMM-YYYY') +
			' - ' +
			moment(this.state.end_date).format('DD-MMM-YYYY') +
			' sebesar Rp. ' +
			this.state.total.toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}) +
			'- (' +
			this.state.terbilang.trim() +
			').';
		var splitTitle = doc.splitTextToSize(terbilang, 500);
		doc.text(splitTitle, 40, 290, {
			lineHeightFactor: 1.5,
			align: 'justify',
			maxWidth: 510,
		});

		doc.text(
			'Untuk pembayaran klaim tersebut harap ditransfer ke No. Rekening:',
			40,
			345
		);
		// let lastY = terbilang.length > 90 ? 12 : 0
		let lastY = 0;

		// doc.setFontType("bold");
		doc.setFont('helvetica', 'bold');
		doc.text(
			'PT. Anugrah Argon Medica',
			300,
			370 + lastY,
			null,
			null,
			'center'
		);
		doc.text('BCA KCP Sentra Menteng', 300, 384 + lastY, null, null, 'center');
		doc.text('Bintaro - Tangerang', 300, 398 + lastY, null, null, 'center');
		doc.text('Acc: 6800573333', 300, 412 + lastY, null, null, 'center');

		// doc.setFontType("normal");
		doc.setFont('helvetica', 'normal');
		doc.text(
			'Adapun data detail reimbursement sebagai berikut:',
			40,
			437 + lastY
		);

		let content = {
			startY: 451 + lastY,
			head: headers,
			body: data,
			columnStyles: { 6: { halign: 'right' } },
			theme: 'grid',
			headStyles: { fillColor: [46, 128, 186] },
			styles: { fontSize: 9 },
		};
		doc.autoTable(content);

		let contentTotal = {
			body: [['Total: ' + this.thousandSeparator(this.state.total)]],
			theme: 'plain',
			margin: { top: 0 },
			styles: { fontSize: 9 },
			columnStyles: { 0: { halign: 'right' } },
		};
		doc.autoTable(contentTotal);

		let finalY = doc.lastAutoTable.finalY;
		doc.text(
			'Demikian yang dapat kami sampaikan. Atas perhatian Bapak/Ibu kami ucapkan terima kasih.',
			40,
			finalY + 20
		);
		doc.text('Hormat kami,', 40, finalY + 45);

		// doc.setFontType("bold");
		doc.setFont('helvetica', 'bold');
		doc.text(this.state.dataOrganization.pic_aam, 40, finalY + 105);

		// doc.setFontType("normal");
		doc.setFont('helvetica', 'normal');
		doc.text(this.state.dataOrganization.pic_aam_tittle, 40, finalY + 119);
		doc.save(this.state.sequence + '.pdf');
	};

	handleCancel = () => {
		this.setState({
			start_date: new Date(),
			end_date: new Date(),
			principal_code: '',
			claim_number: '',
		});
	};

	renderDownload = () => {
		if (this.state.coverLetterPath.length > 0) {
			return (
				<div className='row mt-3'>
					<div className='col-md-6'>
						<div className='card'>
							<div className='card-body'>
								Click this link to download:{' '}
								<a href={this.state.coverLetterPath}>[download]</a>
							</div>
						</div>
					</div>
				</div>
			);
		}
	};
	render() {
		return (
			<div>
				<section className='content'>
					<div className='container-fluid'>
						<div className='row ml-1'>
							<div className='col-lg-12'>
								<div className='card card-info'>
									<div className='card-body'>
										{/* <form className="form-horizontal"> */}
										<div className='row'>
											<div className='col-md-6'>
												<div className='form-group row'>
													<label
														htmlFor='inputEmail3'
														className='col-sm-4 col-form-label'
													>
														Claim Number
													</label>
													<div className='col-sm-8'>
														<input
															type='text'
															autoComplete='off'
															className='form-control'
															id='inputEmail3'
															name='claim_number'
															placeholder='Claim Number'
															onChange={this.handleChangeInput.bind(this)}
															value={this.state.claim_number}
														/>
													</div>
												</div>
												<div className='form-group row'>
													<label
														htmlFor='inputEmail3'
														className='col-sm-4 col-form-label'
													>
														Receive Date (Start)
													</label>
													<div className='col-sm-8'>
														<DatePicker
															selected={this.state.start_date}
															dateFormat='d-MMM-yyyy'
															className='form-control'
															popperPlacement='top-end'
															onChange={this.handleStartDate}
														/>
													</div>
												</div>
											</div>
											<div className='col-md-6'>
												<div className='form-group row'>
													<label
														htmlFor='inputEmail3'
														className='col-sm-4 col-form-label'
													>
														Principal
													</label>
													<div className='col-sm-8'>
														{this.renderLovPrincipal()}
													</div>
												</div>
												<div className='form-group row'>
													<label
														htmlFor='inputEmail3'
														className='col-sm-4 col-form-label'
													>
														Receive Date (End)
													</label>
													<div className='col-sm-8'>
														<DatePicker
															selected={this.state.end_date}
															dateFormat='d-MMM-yyyy'
															className='form-control'
															popperPlacement='top-end'
															onChange={this.handleEndDate}
														/>
													</div>
												</div>
											</div>
										</div>
										<div className='row'>
											<div className='col-md-6'>
												<button
													className='btn btn-success'
													onClick={this.handleGenerate.bind(this)}
												>
													<i className='fa fa-save' /> GENERATE
												</button>{' '}
												&nbsp;
												<button
													className='btn btn-warning'
													onClick={this.handleCancel.bind(this)}
												>
													<i className='fa fa-times' /> CANCEL
												</button>
											</div>
										</div>
										{this.renderDownload()}
										{/* </form> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Loader fullPage loading={this.state.loading} />
			</div>
		);
	}
}

export default CoverLetter;
